import {useNavigate} from "react-router";
import {useQuery} from "react-query";
import http from "../../Services/Network/http";
import DataTable from "react-data-table-component";
import moment from "moment";
import {useParams} from "react-router-dom";

export const SupplierOrders = () => {
    const {period} = useParams();
    const navigate = useNavigate();

    const { data: orders } = useQuery(
        "fetchOrders",
        () => http.get(`/Order`));

    const columns = [
        {
            name: 'Ordre.Nr',
            selector: (row : any) => row.orderId,
            grow: 3
        },
        {
            name: 'Status',
            selector: (row : any) => row.orderStatus?.title,
            grow: 3
        },
        {
            name: 'Bestiller',
            selector: (row : any) => row.createdByUser?.fullName,
            grow: 3
        },
        {
            name: 'Opprettet',
            selector: (row : any) => moment(row.createdAt).format('DD.MM.yyyy HH:mm'),
            grow: 3
        }
    ];


    return (
        <div>
            <h2 style={{float:'left'}}>Leverandør &gt; Ordreliste</h2>
            <DataTable
                highlightOnHover={true}
                onRowClicked={(row) => navigate(`/order/${row.orderId}`)}
                columns={columns}
                data={(orders || []).filter((order : any) => { 
                    if(period === undefined) 
                        return order 
                    else if(new Date(order.createdAt).getFullYear() === parseInt(period ?? "")) 
                        return order
                    return []
                })}
            />
        </div>
    );
}